import { render, staticRenderFns } from "./ShopApplicationsTab.vue?vue&type=template&id=123a9199&scoped=true&"
import script from "./ShopApplicationsTab.vue?vue&type=script&lang=js&"
export * from "./ShopApplicationsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123a9199",
  null
  
)

export default component.exports